import * as React from 'react';
import { Store } from '../../../../stores';
import { inject, observer } from 'mobx-react';
import { IADropDown } from '../../../../../dropDown/DropDown';
import { LocalizationService } from '../../../../../../services/LocalizationService';
import { IPlayProfile } from '../../../../../../interfaces/IPlay';
import PlayService from '../../../../../../services/PlayService';
import { IASpinner } from '../../../../../spinner/Spinner';
import { IAButton } from '../../../../../button/Button';
import * as styles from '../IntegrationsEditPanel.css';
import { IACheckbox } from '../../../../../checkbox/Checkbox';
import { IRoom } from '../../../../../../interfaces/IRoom';
import { IASearch } from '../../../../../search/Search';

export interface IProps {
  store?: Store;
  profiles: IPlayProfile[];
  isEditingExistingIntegration: boolean;
  isDeletingSharepointNewsItem: boolean;
  selectedProfileId: string;
  isConnected: boolean;
  onProfileChange: (profile) => void;
  onConnect: () => void;
  checkIfConnected: () => void;
}

export interface IState {
  availableRooms: IRoom[];
  isLoading: boolean;
  showRefreshButton: boolean;
  searchQuery?: string;
}

@inject('store')
@observer
export class OutlookCalendarIntegrationComponent extends React.Component<IProps, IState> {
  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      availableRooms: [],
      isLoading: true,
      showRefreshButton: false
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentDidMount(): void {
    PlayService.getOutlookCalendarRooms(this.props.store.environment, this.props.store.token, this.props.store.tenantId)
      .then(availableRooms => {
        const sortedRooms = availableRooms.sort((a, b) => a.displayName.localeCompare(b.displayName));
        this.setState({ availableRooms: sortedRooms });
      })
      .finally(() => this.setState({ isLoading: false }));
  }

  public render(): JSX.Element {
    const hasRooms = this.state.availableRooms && this.state.availableRooms.length > 0;
    return (
      <>
        {this.state.isLoading ?
          <IASpinner color={this.props.store.highlightColor} />
          :
          <>
            {this.props.isConnected
              ?
              <>
                <IADropDown
                  label={this.localizationService.strings.PlayAdmin_SelectAProfileToAccess?.toUpperCase()}
                  selectedOption={this.props.store.integrationToEdit?.profileId}
                  options={[{
                    key: undefined,
                    value: this.localizationService.strings.PlayAdmin_SelectAProfileToAccess,
                    disabled: true
                  },
                  ...this.props.profiles.map(profile => { return { key: profile.id, value: profile.title } })
                  ]}
                  disabled={this.props.isEditingExistingIntegration || this.state.isLoading}
                  darkMode={this.props.store.darkMode}
                  highlightColor={this.props.store.highlightColor}
                  onChange={(profile) => {
                    this.props.onProfileChange(profile)
                  }}
                  style={{
                    float: "left",
                    width: 340
                  }}
                  borderRadius={5}
                />
                {this.props.selectedProfileId &&
                  <div style={{
                    marginTop: 20,
                    float: "left",
                    width: "100%"
                  }}>
                    {hasRooms ?
                      <>
                        <label>{this.localizationService.strings.PlayAdmin_SelectRooms?.toUpperCase()}</label>
                        <IASearch
                          searchQuery={this.state.searchQuery || ''}
                          placeholder={this.localizationService.strings.PlayAdmin_SearchRooms}
                          style={{
                            marginTop: 10,
                            marginBottom: 20,
                            width: '100%'
                          }}
                          darkMode={this.props.store.darkMode}
                          borderRadius={5}
                          onChange={(searchQuery) => {
                            this.setState({ searchQuery });
                          }}
                        />
                        <div>
                          {this.state.availableRooms.sort((a, b) => a.displayName.localeCompare(b.displayName)).filter(room => room.displayName.toLowerCase().includes((this.state.searchQuery || '').toLowerCase())).map(room => {
                            return (
                              <IACheckbox
                                key={room.id}
                                label={room.displayName}
                                highlightColor={this.props.store.highlightColor}
                                isChecked={this.props.store.integrationToEdit?.outlookCalendarIntegration?.roomIds.indexOf(room.id) !== -1}
                                onChange={() => {
                                  const index = this.props.store.integrationToEdit?.outlookCalendarIntegration?.roomIds.indexOf(room.id);
                                  if (index === -1) {
                                    this.props.store.integrationToEdit?.outlookCalendarIntegration?.roomIds.push(room.id);
                                  } else {
                                    this.props.store.integrationToEdit?.outlookCalendarIntegration?.roomIds.splice(index, 1);
                                  }
                                }}
                                styles={{
                                  padding: 10,
                                  width: '100%',
                                  boxSizing: 'border-box',
                                  float: 'left'
                                }}
                              />
                            );
                          })}
                        </div>
                      </>
                      :
                      <>{this.localizationService.strings.PlayAdmin_NoFeeds}</>
                    }
                  </div>
                }
              </>
              :
              <div className={styles.IA_feeds}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                  <IAButton
                    label={this.localizationService.strings.PlayAdmin_Connect?.toUpperCase()}
                    buttonColor={this.props.store.highlightColor}
                    disbaled={false}
                    darkMode={this.props.store.darkMode}
                    onClick={() => {
                      this.props.onConnect();
                      this.setState({ showRefreshButton: true });
                    }}
                    borderRadius={5}
                    showSpinner={this.props.store.workingOnIt}
                  />
                  {this.state.showRefreshButton &&
                    <IAButton
                      label={this.localizationService.strings.PlayAdmin_ConnectRefresh?.toUpperCase()}
                      buttonColor={this.props.store.highlightColor}
                      disbaled={false}
                      darkMode={this.props.store.darkMode}
                      onClick={() => {
                        this.props.checkIfConnected();
                      }}
                      borderRadius={5}
                      showSpinner={this.props.store.workingOnIt}
                    />
                  }
                </div>
              </div>
            }
          </>
        }
      </>
    );
  }
}